import React from 'react';
import { m } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { scrollToId } from '../utils/scroll';
const rows = [{
  n: '1/4',
  title: 'Planificación',
  before: 'Noches de domingo buscando ejercicios en YouTube que no terminan de encajar.',
  after: '−90% tiempo. Sesiones listas en tu móvil en solo 2 clics.'
}, {
  n: '2/4',
  title: 'Seguridad',
  before: 'Inseguridad al entrenar grupos con niveles mezclados o jugadores que no progresan.',
  after: 'Confianza total. Progresiones claras, pedagógicas y medibles semana a semana.'
}, {
  n: '3/4',
  title: 'Variedad',
  before: 'Los mismos 10 ejercicios de siempre que tus jugadores ya conocen de memoria.',
  after: '+100% originalidad. Ejercicios dinámicos con consignas que motivan y desafían.'
}, {
  n: '4/4',
  title: 'Energía',
  before: 'Llegas al pabellón mentalmente cansado de haber organizado todo desde cero.',
  after: 'Cero estrés. Llegas con energía para conectar con tus jugadores desde el primer minuto.'
}];
const footerStats = [{
  value: '+120h',
  label: 'Ahorradas al año'
}, {
  value: '2 clics',
  label: 'Para cada sesión lista'
}, {
  value: '100%',
  label: 'Profesional'
}];
export function Transformation() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-291" data-mp="mgdmg9pcac5x">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-292" data-mp="rh1mtlzgk5ct">
        <SectionTag icon="⚡" data-id="element-293" data-mp="dh09h720b5gg">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-294" data-mp="dil4exs8gqeu">
          De un entrenador agotado a un profesional inspirado.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-295" data-mp="27w2w8wzo89fo">
          Esto es lo que cambia desde la primera semana con El Manual en tus manos.
        </p>

        <div className="mt-6 rounded-2xl border border-orange/20 bg-orange/5 p-5 text-left sm:p-6" data-id="element-296" data-mp="3ku31xzgnk0s0">
          <p className="font-heading text-sm font-semibold uppercase tracking-wide text-orange" data-id="element-297" data-mp="3ftyxj7t0qwi5">
            Recupera tus domingos
          </p>
          <p className="mt-2 text-sm leading-relaxed text-muted sm:text-base" data-id="element-298" data-mp="3btewht5br8qq">
            <span className="font-semibold text-white" data-id="element-299" data-mp="36v3q5se8ngd9">El coste real:</span> Planificar manualmente te
            quita de 3 a 5 horas por semana. Es el equivalente a un mes entero de trabajo al año quemado en
            YouTube, cuadernos y dudas mentales.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-300" data-mp="3uqpp4uwgb3x7">
        <div className="space-y-4" data-id="element-301" data-mp="3pswhdxfi21ut">
          {rows.map((row, i) => <m.div key={row.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="rounded-2xl border border-white/10 bg-bg-secondary p-5 sm:p-6" data-id="element-302" data-mp="3pqk0lnlh9xjc" data-mpi={i}>
              <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-303" data-mp="yldq9207z6gs">
                {row.title} · {row.n}
              </p>
              <div className="grid gap-4 sm:grid-cols-2" data-id="element-304" data-mp="13ncv6gblybfu">
                <div className="flex items-start gap-3" data-id="element-305" data-mp="17nwof8t28uwp">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-danger/15" data-id="element-306" data-mp="1cly9fza1r4at">
                    <XIcon size={14} className="text-danger" data-id="element-307" data-mp="1hkhyi8jxsw7e" />
                  </div>
                  <div data-id="element-308" data-mp="1mbzzgwlymwsd">
                    <p className="text-xs font-semibold uppercase tracking-wide text-danger" data-id="element-309" data-mp="1mcsuj0bk3xuo">Antes</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-310" data-mp="1r9t2xhvvpcoy">{row.before}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-311" data-mp="1vacyih0t088z">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-success/15" data-id="element-312" data-mp="20ckgpoc88kjr">
                    <CheckIcon size={14} className="text-success" data-id="element-313" data-mp="1mn90a5i6o3ck" />
                  </div>
                  <div data-id="element-314" data-mp="1imf8h11me4ee">
                    <p className="text-xs font-semibold uppercase tracking-wide text-success" data-id="element-315" data-mp="1il47f8zk7aqz">Ahora</p>
                    <p className="mt-1 text-sm leading-relaxed text-white" data-id="element-316" data-mp="1wgpwfg5sluje">{row.after}</p>
                  </div>
                </div>
              </div>
            </m.div>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-317" data-mp="13s0s789fx93f">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-318" data-mp="zpe5flrmmed3">Quiero esta transformación</PrimaryButton>
        </div>

        <div className="mt-8" data-id="element-319" data-mp="1dpov4lh79mwo">
          <ScrollHintTable minWidth="480px" data-id="element-320" data-mp="1dlrdk4a9t3ew">
            <div className="grid grid-cols-3 divide-x divide-white/10" data-id="element-321" data-mp="18nzij1ebx16h">
              {footerStats.map(stat => <div key={stat.label} className="flex flex-col items-center gap-1 px-3 py-6 text-center" data-id="element-322" data-mp="2p1pqwkcheblx">
                  <span className="font-heading text-xl font-bold text-orange sm:text-2xl" data-id="element-323" data-mp="2k3xzdrfr0ri9">{stat.value}</span>
                  <span className="text-xs text-muted sm:text-sm" data-id="element-324" data-mp="5yj8z61zj717">{stat.label}</span>
                </div>)}
            </div>
          </ScrollHintTable>
        </div>
      </div>
    </section>;
}